import styles from "./index.module.scss";
import { useServices } from "@/services-context";
import ChristmasTreeLeft from "@/assets/holiday-alert/christmas-tree-left.svg";
import ChristmasTreeLeftMob from "@/assets/holiday-alert/christmas-tree-left-mob.svg";
import ChristmasTreeRight from "@/assets/holiday-alert/christmas-tree-right.svg";
import ChristmasTreeRightMob from "@/assets/holiday-alert/christmas-tree-right-mob.svg";
import ChristmasLightLeft from "@/assets/holiday-alert/christmas-light-left.svg";
import ChristmasLightRight from "@/assets/holiday-alert/christmas-light-right.svg";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import classNames from "classnames";

function NyAlert() {
  const { holidays } = useServices();
  const { layoutType, defaultLayoutStyleType } = useLayoutType();

  const nyEvents = holidays?.getNy();

  if (nyEvents) {
    return (
      <div className={classNames(styles.nyAlert, styles[defaultLayoutStyleType])}>
        {layoutType === LayoutTypes.TYPE_MOBILE && (
          <>
            <div className={classNames(styles.christmasTreeLeft)}>
              <img src={ChristmasTreeLeftMob} alt="" aria-hidden="true" width={48} height={118} />
            </div>
            <div className={classNames(styles.content)}>
              <div className={classNames(styles.christmasLightLeft)}>
                <img src={ChristmasLightLeft} alt="" aria-hidden="true" width={186} height={36} />
              </div>

              <div className={classNames(styles.message)}>{nyEvents.message}</div>
            </div>
            <div className={classNames(styles.christmasTreeRight)}>
              <img src={ChristmasTreeRightMob} alt="" aria-hidden="true" width={48} height={118} />
            </div>
          </>
        )}

        {layoutType === LayoutTypes.TYPE_DESKTOP && (
          <>
            <div className={classNames(styles.christmasTreeLeft)}>
              <img src={ChristmasTreeLeft} alt="" aria-hidden="true" width={28} height={40} />
            </div>
            <div className={classNames(styles.christmasLightLeft)}>
              <img src={ChristmasLightLeft} alt="" aria-hidden="true" width={186} height={36} />
            </div>

            <div className={classNames(styles.message)}>{nyEvents.message}</div>

            <div className={classNames(styles.christmasLightRight)}>
              <img src={ChristmasLightRight} alt="" aria-hidden="true" width={186} height={36} />
            </div>
            <div className={classNames(styles.christmasTreeRight)}>
              <img src={ChristmasTreeRight} alt="" aria-hidden="true" width={28} height={40} />
            </div>
          </>
        )}
      </div>
    );
  }

  return <></>;
}

export default NyAlert;
